import { Brand, createBranded } from '@deltasierra/type-utilities';

export type ReportingPublishedTemplateId = Brand<number, 'ReportingPublishedTemplateId'>;
export const ReportingPublishedTemplateId = createBranded<ReportingPublishedTemplateId>();
